'use client';

import { ReactNode } from 'react';

import { BlogPageType, urlMap } from '@/fo/feature/article/page/blog';

import { PostFooter, PreviewBlock, TableOfContents } from '../components';
import { ArticlePost, TableOfContentsItem } from '../types';

import { styles } from './UiArticlePagePost.styles';

export interface UiArticlePagePostProps {
  post: ArticlePost;
  tableOfContents: TableOfContentsItem[];
  type: BlogPageType;
  commentsSection: ReactNode;
  content: ReactNode;
}

export function UiArticlePagePost({
  post,
  tableOfContents,
  type,
  commentsSection,
  content
}: UiArticlePagePostProps) {
  const slots = styles();

  const withSidebar = !!tableOfContents.length;

  return (
    <div className={slots.base()}>
      <div className={slots.layout()}>
        {withSidebar && (
          <div className={slots.sidebar()}>
            <TableOfContents items={tableOfContents} />
          </div>
        )}
        <div className={slots.content()}>
          <PreviewBlock post={post} />
          {content}
        </div>
      </div>
      <div className={slots.layout()}>
        {withSidebar && (
          <div className={slots.sidebar({ sidebarHidden: true })} />
        )}
        <div className={slots.content()}>
          <PostFooter
            post={post}
            backLink={`/about-skin/${urlMap[type]}`}
            currentLink={`/about-skin/${urlMap[type]}/${post.slug}`}
          />
        </div>
      </div>
      <div className={slots.layout()}>
        {withSidebar && (
          <div className={slots.sidebar({ sidebarHidden: true })} />
        )}
        <div className={slots.content()}>{commentsSection}</div>
      </div>
    </div>
  );
}
